
import React from 'react';
import content from '../data/content';
import '../styles/Contact.css';

function Contact() {
  const { organizationInfo } = content;

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2>{organizationInfo.title}</h2>
        <ul className="organization-details">
          {organizationInfo.details.map((detail, index) => (
            <li key={index}>
              <strong>{detail.label}:</strong>
              {detail.label === '顧問' ? (
                <a href={organizationInfo.advisorLink} target="_blank" rel="noopener noreferrer">
                  {detail.value}
                </a>
              ) : detail.label === '所属大学' ? (
                <a href={organizationInfo.universityLink} target="_blank" rel="noopener noreferrer">
                  {detail.value}
                </a>
              ) : (
                <span> {detail.value}</span>
              )}
            </li>
          ))}
        </ul>
        <div id="sns" className="sns-section">
          <h3>SNS</h3>
          <p className="youtube-description">YouTubeに動画を投稿しています！</p>
          <div className="youtube-embed">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/YoYJDSeLPS0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen>
            </iframe>
          </div>
          <a href="https://lit.link/KVRP" className="external-article-widget" rel="noopener noreferrer nofollow" target="_blank">
            <img src="/images/LitLink.jpg" alt="KVRP" className="external-article-widget-image" />
            <div className="external-article-widget-content">
              <strong className="external-article-widget-title">
                KVRP lit.link
              </strong>
              <em className="external-article-widget-description">
                各種SNSはこちらから
              </em>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
